import React from "react";
import styled from "styled-components";
import styles from "./index.module.css";
import { IAppContext } from "../../../interfaces";
import { useDropzone } from "react-dropzone";
import { Trans } from "react-i18next";
import classNames from "classnames";

interface DropZoneProps {
  onDrop: (files: File[]) => void;
  multiple?: boolean;
  backgroundColor?: "white" | "grey" | "purple";
  disabled?: boolean;
  showIcon?: any;
}

const StyledDropZone = styled.div<any>`
  width: 100%;
  cursor: pointer;
  outline: none;
  transition: all 300ms ease-in-out;
  border-radius: 6px;
  padding: 15px;

  &.drag-active {
    border: 1px dashed ${(p: IAppContext) => p.theme.skye.colors.primary};
    background-color: transparent;
  }

  &.white {
    border: 1px dashed ${(p: IAppContext) => p.theme.skye.colors.silverChalice};
    background-color: ${(p: IAppContext) => p.theme.skye.colors.backgroundCard};
  }

  &.grey {
    border: 1px dashed ${(p: IAppContext) => p.theme.skye.colors.background};
    background-color: ${(p: IAppContext) => p.theme.skye.colors.whiteSmoke};
  }

  &.purple {
    border: 1px dashed ${(p: IAppContext) => p.theme.skye.colors.electricViolet};
    background-color: ${(p: IAppContext) => p.theme.skye.colors.lavender};
  }
`;

const getLabel = (isDragActive: boolean, multiple: boolean): string => {
  if (isDragActive) {
    return multiple ? "dropFilesHere" : "dropFileHere";
  }
  return multiple ? "dragAndDropOrSelectFiles" : "dragAndDropOrSelectFile";
};

const DropZone = ({
  onDrop,
  multiple = true,
  backgroundColor = "white",
  disabled,
  showIcon = true,
}: DropZoneProps) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple,
    disabled,
  });

  return (
    <StyledDropZone
      {...getRootProps()}
      className={classNames([
        "drop-zone",
        backgroundColor,
        { "drag-active": isDragActive },
      ])}
    >
      <input {...getInputProps()} />
      <div className="drop-zone-content flex flex-col items-center justify-center h-full gap-y-4">
        {showIcon && (
          <img
            className="h-20"
            alt="drop-zone"
            src="/images/upload_video.svg"
          />
        )}
        <h6
          className={classNames([
            "text-center text-text-primary description text-sm font-normal",
            styles["drop-zone-text"],
          ])}
        >
          <Trans>{getLabel(isDragActive, multiple)}</Trans>
        </h6>
      </div>
    </StyledDropZone>
  );
};

export default DropZone;
